import { Sparkles } from "lucide-react";
import { BOOKING_URL } from "@/constants";

// Auto-hide after July 12, 2026 (inclusive). On July 13+ this component renders nothing.
const PROMO_END_DATE = new Date("2026-07-13T00:00:00");

export const isPromoActive = () => new Date() < PROMO_END_DATE;

const PROMO_URL = (() => {
  const u = new URL(BOOKING_URL);
  u.searchParams.set("offer", "limited-time-20");
  return u.toString();
})();

export const LimitedTimePromoBanner = () => {
  if (!isPromoActive()) return null;

  return (
    <a
      href={PROMO_URL}
      target="_blank"
      rel="noopener noreferrer"
      className="fixed top-10 left-0 right-0 z-[45] block w-full bg-gradient-to-r from-[#D4AF37] via-[#E5C158] to-[#D4AF37] text-[#1E407C] h-14 sm:h-10 hover:opacity-95 transition-opacity shadow-md"
      data-testid="limited-time-promo-banner"
    >
      <div className="max-w-7xl mx-auto px-3 sm:px-4 h-full flex items-center justify-center gap-2 sm:gap-3 text-center">
        <Sparkles size={14} className="text-[#1E407C] shrink-0" />
        <div className="leading-tight">
          <p className="font-bold text-[12px] sm:text-sm md:text-base">
            Limited Time Promotional Offer — 20% Off
          </p>
          <p className="text-[9px] sm:text-[10px] md:text-xs text-[#1E407C]/75 leading-tight">
            Book by July 13 · Stay June 2 – Dec 15 · Min 1 night · Cancel 72 hrs prior · Blackout dates and restrictions apply
          </p>
        </div>
      </div>
    </a>
  );
};
